import * as yup from 'yup';

export const travelDetailsValidationSchema = yup.object().shape({
  travelDetails: yup.object().shape({
    departureId: yup.string().required('Departure is required'),
    destinationId: yup.string().required('Destination is required'),

    duration: yup
      .number()
      .required('Duration is required')
      .positive('Duration cannot be negative')
      .integer('Duration must be a whole number')
      .typeError('Duration must be a number'),

    numberOfAdherent: yup
      .number()
      .nullable()
      .transform((value, originalValue) =>
        originalValue === '' ? null : value
      )
      .min(0, 'Number of adherents cannot be negative')
      .typeError('Number of adherents must be a number')
  })
});
